import React, { useState } from "react";
import Layout from "../Layout";
import HeaderSection from "../../../widgets/management/freed-people/HeaderSection/HeaderSection";
import TabContent from "../../../widgets/management/freed-people/TabContent/TabContent";
import { Box } from "@mui/material";

function FreedPeople() {
  const [tabIndex, setTabIndex] = useState(0);
  const [search, setSearch] = useState("");

  const handleTabChange = (_, newValue) => setTabIndex(newValue);

  return (
    <Layout>
      <Box
        elevation={3}
        sx={{
          borderRadius: 3,
        }}
      >
        <HeaderSection
          tabIndex={tabIndex}
          handleTabChange={handleTabChange}
          search={search}
          setSearch={setSearch}
        />

        <TabContent tabIndex={tabIndex} search={search} />
      </Box>
    </Layout>
  );
}

export default FreedPeople;
